import { render, staticRenderFns } from "./website-subdomain.vue?vue&type=template&id=0b7ffb02&scoped=true&"
import script from "./website-subdomain.vue?vue&type=script&lang=js&"
export * from "./website-subdomain.vue?vue&type=script&lang=js&"
import style0 from "./website-subdomain.vue?vue&type=style&index=0&id=0b7ffb02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7ffb02",
  null
  
)

export default component.exports